import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _get from 'lodash/get';
import _without from 'lodash/without';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import { getNumber } from '../utils';
import { PAYMENT_TYPES, EMPTY_PROGRAM_RESIDUAL_DISPLAY_TYPE_VS_PAYMENT_TYPE } from '../constants/desking.constants';
import { REBATE_TYPES } from '../../constants/retail/rebate.constants';
import { LENDER_TIERS } from '../../constants/retail/marketScan';
export function isLoanOrLeasePaymentType(paymentType) {
  return [PAYMENT_TYPES.LOAN, PAYMENT_TYPES.LEASE].includes(paymentType);
}
export function isLoanOrCashPaymentType(paymentType) {
  return [PAYMENT_TYPES.LOAN, PAYMENT_TYPES.CASH].includes(paymentType);
}
export function isLeseOrOPLeasePaymentType(paymentType) {
  return [PAYMENT_TYPES.LEASE, PAYMENT_TYPES.ONE_TIME_LEASE].includes(paymentType);
}
export function isLeaseOrBalloonPaymentType(paymentType) {
  return [PAYMENT_TYPES.LEASE, PAYMENT_TYPES.BALLOON].includes(paymentType);
}
export function isLeaseOrOPLeaseOrBalloonPaymentType(paymentType) {
  return [PAYMENT_TYPES.LEASE, PAYMENT_TYPES.ONE_TIME_LEASE, PAYMENT_TYPES.BALLOON].includes(paymentType);
}
export function isLoanOrLeaseOrBalloonPaymentType(paymentType) {
  return [PAYMENT_TYPES.LOAN, PAYMENT_TYPES.LEASE, PAYMENT_TYPES.BALLOON].includes(paymentType);
}
export function isLoanOrBalloonPaymentType(paymentType) {
  return [PAYMENT_TYPES.LOAN, PAYMENT_TYPES.BALLOON].includes(paymentType);
}
export function isBalloonPaymentType(paymentType) {
  return [PAYMENT_TYPES.BALLOON].includes(paymentType);
}
export function isLoanOrCashOrBalloonPaymentType(paymentType) {
  return [PAYMENT_TYPES.LOAN, PAYMENT_TYPES.CASH, PAYMENT_TYPES.BALLOON].includes(paymentType);
}
export function isCashPaymentType(paymentType) {
  return [PAYMENT_TYPES.CASH].includes(paymentType);
}
export function isLoanPaymentType(paymentType) {
  return [PAYMENT_TYPES.LOAN].includes(paymentType);
}
export function isLeasePaymentType(paymentType) {
  return [PAYMENT_TYPES.LEASE].includes(paymentType);
}
export function isOnePayPaymentType(paymentType) {
  return [PAYMENT_TYPES.ONE_TIME_LEASE].includes(paymentType);
}
export function isFullPaymentType(paymentType) {
  return [PAYMENT_TYPES.ONE_TIME_LEASE, PAYMENT_TYPES.CASH].includes(paymentType);
}
export var getDealerCashRebates = function getDealerCashRebates(rebates) {
  return _filter(rebates, function (_ref) {
    var deleted = _ref.deleted,
        rebateType = _ref.rebateType;
    return !deleted && rebateType === REBATE_TYPES.DEALER_CASH;
  });
};
export var getNonDealerCashRebates = function getNonDealerCashRebates(rebates) {
  return _filter(rebates, function (_ref2) {
    var deleted = _ref2.deleted,
        rebateType = _ref2.rebateType;
    return !deleted && rebateType === REBATE_TYPES.REBATE;
  });
};
export var filterWaiverRebate = function filterWaiverRebate(rebates) {
  return _filter(rebates, function (_ref3) {
    var firstMonthWaiver = _ref3.firstMonthWaiver;
    return !firstMonthWaiver;
  });
};
export var getDefaultRebates = function getDefaultRebates(rebates) {
  return _filter(rebates, function (_ref4) {
    var deleted = _ref4.deleted,
        custom = _ref4.custom;
    return !deleted && !custom;
  });
};
export var getModifiedZipForMS = function getModifiedZipForMS(zip) {
  return (zip || '').slice(0, 5);
};
export var checkForActiveContracts = function checkForActiveContracts(penInfo) {
  var productContractInfos = _get(penInfo, 'productContractInfos') || [];
  var hasActiveContract = productContractInfos.reduce(function (status, product) {
    var contractNumber = product.contractNumber;
    if (contractNumber || status) return true;
    return false;
  }, false);
  return hasActiveContract;
};
export function getRequiredFields(rows, fieldsToBeRemoved) {
  var rowsWithRequiredFields = rows.reduce(function (withRequiredFields, row) {
    var columns = row.columns;
    withRequiredFields.push({
      columns: _without.apply(void 0, [columns].concat(_toConsumableArray(fieldsToBeRemoved)))
    });
    return withRequiredFields;
  }, []);
  return rowsWithRequiredFields;
}
export function addMilesToAnnualMileage(annualMileage, totalMilesToAdd, totalTermMonths, roundOffMileageToNearestThousand) {
  var year = getNumber(totalTermMonths) / 12;
  var extraAnnualMiles = year > 0 ? Math.round(totalMilesToAdd / year) : totalMilesToAdd;
  var yearlyMilesWithOdo = getNumber(annualMileage) + getNumber(extraAnnualMiles);

  if (roundOffMileageToNearestThousand) {
    return Math.round(yearlyMilesWithOdo / 1000) * 1000;
  }

  return yearlyMilesWithOdo;
}
export var getRemoveDemoMileageFromAnnualMileage = function getRemoveDemoMileageFromAnnualMileage(_ref5, totalYearlyMiles) {
  var removeDemoMileageFromAnnualMileage = _ref5.removeDemoMileageFromAnnualMileage,
      removeDemoMileageFromAnnualMileageDeciderValue = _ref5.removeDemoMileageFromAnnualMileageDeciderValue;
  var valueToCompare = getNumber(removeDemoMileageFromAnnualMileageDeciderValue);

  if (removeDemoMileageFromAnnualMileage && valueToCompare > 0) {
    return getNumber(totalYearlyMiles) > valueToCompare;
  }

  return false;
};
export var getDefaultTierForPaymentType = function getDefaultTierForPaymentType(paymentType, tiers) {
  var isLeaseType = isLeseOrOPLeasePaymentType(paymentType);
  return _find(tiers, function (_ref6) {
    var type = _ref6.type;
    return isLeaseType ? type === LENDER_TIERS.LEASE : type === LENDER_TIERS.RETAIL;
  });
};
export var residualValueForEmptyProgramInfo = function residualValueForEmptyProgramInfo(paymentType) {
  return {
    residualOverridden: false,
    residualDisplayType: EMPTY_PROGRAM_RESIDUAL_DISPLAY_TYPE_VS_PAYMENT_TYPE[paymentType]
  };
};